import React from "react";
const DsHorizontalDivider = ():JSX.Element =>{
    return <div className="ds-dividers ds-dividers--thin ds-dividers--full_solid ds-dividers--horizontal ds-dividers--top"></div>
}
export default DsHorizontalDivider;